<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>Exports</v-toolbar-title>
            <v-icon large class="ml-6" @click="loadItems">
                mdi-refresh
            </v-icon>
        </v-toolbar>
        <v-container fluid>
            <v-row no-gutters>
                <v-col>
                    <v-data-table
                        :headers="headers"
                        :items="allResultData"
                        item-key="id"
                        @click:row="rowSelected"
                        @current-items="currentItems"
                        :options.sync="pagination"
                        :server-items-length="totalRecords"
                        :loading="waiting"
                        :footer-props="{'items-per-page-options':[15, 30, 50, 100]}"
                        class="elevation-1"
                        @update:options="loadItems">
                        <template v-slot:item.actions="{ item }">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn color="accent" v-on="on">
                                        <span style="color: #000000;">Actions</span>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item
                                        v-for="(actionItem, index) in actionItems"
                                        :key="index"
                                        @click="testAction(index, item)">
                                        <v-list-item-icon><v-icon color="black" v-text="actionItem.icon"></v-icon></v-list-item-icon>
                                        <v-list-item-content><v-list-item-title v-text="actionItem.title"></v-list-item-title></v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        <ConfirmationDialog v-if="confirmReportDelete" :params="confirmReportDeleteParams" @confirmation-dialog-response="confirmReportDeleteHandler"></ConfirmationDialog>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import ConfirmationDialog from '@/components/confirmation-dialog'

    export default
    {
        name: 'mm-results-export-list',
        components:
        {
            ConfirmationDialog
        },
        data: function ()
        {
            return {
                doSelectRowAction: true,
                pagination: {},
                headers:
                [
                    {
                        text: 'Actions',
                        width: '150px',
                        value: 'actions',
                        sortable: false
                    },
                    {
                        text: 'Report ID',
                        value: 'guid',
                        width: '290px',
                        sortable: false
                    },
                    {
                        text: 'Created Date',
                        width: '200px',
                        value: 'createdAt',
                        sortable: false
                    },
                    {
                        text: 'Patient ID',
                        width: '200px',
                        value: 'mrn',
                        sortable: false
                    },
                    {
                        text: 'Test Mode',
                        value: 'operationalMode',
                        width: '90px',
                        sortable: false
                    },
                    {
                        text: 'Eye Location',
                        value: 'eyeLocation',
                        width: '110px',
                        sortable: false
                    },
                    {
                        text: 'Visit Date',
                        width: '190px',
                        value: 'visitDate',
                        sortable: false
                    },
                    {
                        text: 'Export Type',
                        value: 'exportType',
                        width: '110px',
                        sortable: false
                    }
                ],
                actionItems:
                [
                    { title: 'Download', icon: 'mdi-cloud-download' },
                    { title: 'Delete', icon: 'mdi-delete' }
                ],
                confirmReportDelete: false,
                confirmReportDeleteParams:
                {
                    title: 'Delete Report',
                    text: '',
                    positiveResponse: 'Yes',
                    negativeResponse: 'No'
                },
            }
        },
        mounted()
        {
            this.loadItems()
        },
        computed:
        {
            ...mapState('exportResult',
            {
                allResultData: state => state.allResultData,
                resultData: state => state.resultData,
                totalRecords: state => state.totalRecords
            }),
            ...mapState('auth',
            {
                currentUser: state => state.currentUser
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            })
        },
        methods:
        {
            ...mapActions('exportResult', ['GET_ALL_RESULT_DATA', 'GET_RESULT_DATA', 'DELETE_RESULT_DATA']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            async rowSelected(item)
            {
                if (this.doSelectRowAction)
                {
                    this.doSelectRowAction = false;
                    try
                    {
                        this.HIDE_SNACKBAR();
                        this.WAITING(true);
                        await this.GET_RESULT_DATA({guid: item.guid});
                        window.location = this.resultData.reportUrl
                    }
                    catch (error)
                    {
                        this.SHOW_SNACKBAR_ERROR(error.message);
                    }
                    this.WAITING(false)
                }
                this.doSelectRowAction = true
            },
            currentItems(items)
            {
                if (this.pagination.page !== 1 && 0 === items.length)
                {
                    this.pagination.page -= 1
                }
            },
            async loadItems()
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    await this.GET_ALL_RESULT_DATA({pagination: this.pagination, search: this.search})
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message);
                }
                this.WAITING(false)
            },
            async testAction(index, item)
            {
                switch (index)
                {
                    case 0: // Download
                        await this.rowSelected(item);
                        break
                    default: // Delete
                        await this.deleteItem(item)
                }
            },
            async deleteItem(item)
            {
                this.doSelectRowAction = false;
                this.confirmReportDeleteParams.context = item;
                this.confirmReportDeleteParams.text = `Are you sure you want to delete Report ID: ${item.guid}?`;
                this.confirmReportDelete = true
            },
            async confirmReportDeleteHandler(payload)
            {
                this.confirmReportDelete = false;
                // If the report should be deleted
                if (payload.response)
                {
                    try
                    {
                        this.HIDE_SNACKBAR();
                        this.WAITING(true);
                        await this.DELETE_RESULT_DATA({guid: payload.context.guid});
                        this.loadItems()
                    }
                    catch (error)
                    {
                        this.SHOW_SNACKBAR_ERROR(error.message);
                    }
                    this.WAITING(false)
                }
            }
        }
    }

</script>

<style scoped>
</style>